<template>
  <iconsWrapper
    :width="width"
    :height="height"
    :viewBox="viewBox"
    class="icon-class"
  >
    <path
      d="M24.0693 0C10.771 0 0 10.74 0 24C0 37.26 10.771 48 24.0693 48C37.3675 48 48.1385 37.26 48.1385 24C48.1385 10.74 37.3675 0 24.0693 0ZM39.1126 15.75C39.1126 16.44 38.8117 17.1 38.3303 17.58L21.7827 34.14C21.3013 34.62 20.6093 34.89 19.9474 34.89C19.2855 34.89 18.6236 34.65 18.1121 34.14L9.74805 25.77C9.26667 25.23 8.99589 24.57 9.02597 23.91C9.02597 23.22 9.32684 22.59 9.83831 22.11C10.8312 21.21 12.516 21.24 13.4788 22.2L19.9474 28.68L34.6898 13.92C35.1712 13.44 35.803 13.17 36.4649 13.14C37.2171 13.14 37.879 13.41 38.3604 13.92C38.8418 14.43 39.1126 15.06 39.1126 15.75Z"
      fill="#012464"
    />
  </iconsWrapper>
</template>

<script>
import iconsWrapper from '@/components/icons/iconsWrapper.vue';
export default {
  name: 'IconCheck',
  components: {
    iconsWrapper,
  },
  props: {
    iconColor: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 47,
    },
    height: {
      type: [Number, String],
      default: 47,
    },
    viewBox: {
      type: String,
      default: '0 0 49 49',
    },
  },
};
</script>

<style scoped></style>
